import getHelper from '../../../services/getHelper';

export default getHelper('/jury-sessions/:id', {
  signPv: getHelper('/sign-pv'),
  assessments: getHelper('/assessments/:id', {
    results: getHelper('/results/:id'),
  }),
  eligibleStudents: getHelper('/eligible-students'),
});
